import axios from "axios";

export const getApiBaseUrl = (): string => {
  const env = import.meta.env.VITE_ENV;
  // const urlMap: Record<string, string> = {
  //     development: import.meta.env.VITE_API_BASE_URL_DEV,
  //     staging:     import.meta.env.VITE_API_BASE_URL_STAGING,
  //     production:  import.meta.env.VITE_API_BASE_URL_PROD,
  // };
  // const baseUrl = urlMap[env] ?? import.meta.env.VITE_API_BASE_URL;
  //
  //const baseUrl = "https://api-index.marcelvilasis.com";
  const baseUrl = "https://api.index-360.com";

  if (!baseUrl) {
    throw new Error(`No se encontró la URL base para el entorno: ${env}`);
  }

  return baseUrl;
};

export const createApiClient = (relative_url: string) => {
  const baseURL = getApiBaseUrl();

  const apiClient = axios.create({
    baseURL: `${baseURL}/${relative_url}`,
    withCredentials: true,
  });

  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        import("../app/store").then(({ store }) => {
          import("./auth/authSlice").then(({ logout }) => {
            store.dispatch(logout());
          });
        });
      }
      return Promise.reject(error);
    },
  );

  return apiClient;
};

export const apiAms = (relative_url: string) => {
  const baseURL = "https://ams.index-360.com";

  const apiClient = axios.create({
    baseURL: `${baseURL}/${relative_url}`,
    withCredentials: true,
  });

  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        import("../app/store").then(({ store }) => {
          import("./auth/authSlice").then(({ logout }) => {
            store.dispatch(logout());
          });
        });
      }
      return Promise.reject(error);
    },
  );

  return apiClient;
};

export const getAdminToken = () => {
  const adminToken = localStorage.getItem("adminToken");

  if (!adminToken) {
    throw new Error("No se encontró el token de administrador");
  }
  return adminToken;
};

export const handleGetRequest = async <T>(
  apiClient: ReturnType<typeof axios.create>,
  url: string,
  token?: string | null,
): Promise<T> => {
  const res = await apiClient.get<T>(url, {
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
    },
  });
  return res.data;
};

export const handlePostRequest = async <T>(
  apiClient: ReturnType<typeof axios.create>,
  url: string,
  data: any,
  token: string | null,
): Promise<T> => {
  try {
    const res = await apiClient.post<T>(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Error en la solicitud POST:", error);
    throw error;
  }
};
